/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string()
    .required(i18n.t('REQUIRED_FIELD_KEY'))
    .max(32, i18n.t('MAX_LENGTH_KEY', { value: 32 })),
  description: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  from_template: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
});
